module.exports = __webpack_public_path__ + "img/gp.f81ac356.png";